import Config from '../config';
export const QUIZSURF_API = Config.API_SERVER_URL + '/api';
